module.exports = __webpack_public_path__ + "img/teamImg16.1ae51b2b.jpg";